module.exports = __webpack_public_path__ + "img/lenovo.5d31abaf.png";